var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-lib-selector yxtbiz-lib-flex" },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-lib-selector__left" },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-lib-flex" },
            [
              _vm.needCreateLib &&
              (_vm.checkActionAdminPermission(
                "questionBank_add_oepn_operate"
              ) ||
                _vm.checkActionAdminPermission(
                  "questionBank_add_private_operate"
                ))
                ? _c(
                    "div",
                    { staticClass: "col-flex-1" },
                    [
                      _c(
                        "yxt-button",
                        {
                          staticClass: "mr12",
                          attrs: { type: "primary" },
                          on: { click: _vm.openLibDetailDrawer },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_ote_btn_createquestionlib" /* 新建题库 */
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("catalogDropdown", {
                staticClass: "mr12 width144 d-in-block",
                attrs: {
                  size: "small",
                  data: _vm.catalogDatas,
                  dropToolTip: _vm.$t("pc_biz_ote_lbl_classification"),
                  catalogId: _vm.params.catalogId,
                  catalogName: _vm.params.catalogName,
                },
                on: {
                  "update:catalogId": function ($event) {
                    return _vm.$set(_vm.params, "catalogId", $event)
                  },
                  "update:catalog-id": function ($event) {
                    return _vm.$set(_vm.params, "catalogId", $event)
                  },
                  "update:catalogName": function ($event) {
                    return _vm.$set(_vm.params, "catalogName", $event)
                  },
                  "update:catalog-name": function ($event) {
                    return _vm.$set(_vm.params, "catalogName", $event)
                  },
                  change: _vm.catalogChange,
                },
              }),
              _c("yxt-input", {
                staticClass: "d-in-block",
                class: _vm.$isChinese ? "width240" : "width280",
                attrs: {
                  placeholder: _vm.$t("pc_biz_ote_lbl_queslibsearch"),
                  size: "small",
                  searchable: "",
                },
                on: { search: _vm.search },
                model: {
                  value: _vm.params.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "keyword", $$v)
                  },
                  expression: "params.keyword",
                },
              }),
            ],
            1
          ),
          _c(
            "yxt-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.quesLoading,
                  expression: "quesLoading",
                },
              ],
              ref: "libTable",
              staticClass:
                "mt16 width-percent-100 yxtbiz-lib-selector__left-table",
              attrs: {
                data: _vm.quesTableList,
                height: _vm.tableHeight,
                "default-sort": _vm.tableDefaultSort,
                "row-key": _vm.getRowKey,
              },
              on: {
                "radio-change": _vm.radioChange,
                "selection-change": _vm.selectionChange,
                "sort-change": _vm.sortChange,
              },
            },
            [
              _vm.needMutiple
                ? _c("yxt-table-column", {
                    attrs: {
                      type: "selection",
                      width: "32",
                      "reserve-selection": "",
                    },
                  })
                : _c("yxt-table-column", {
                    attrs: { type: "radio", width: "32" },
                  }),
              _c("yxt-table-column", {
                attrs: {
                  prop: "name",
                  label: _vm.$t("pc_biz_ote_lbl_quesbankname"),
                  "min-width": 200,
                  "show-overflow-tooltip": false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "yxtbiz-table-row" },
                          [
                            _c(
                              "yxt-tooltip",
                              {
                                staticClass: "yxtbiz-table-row__name",
                                attrs: {
                                  content: scope.row.name,
                                  "open-filter": "",
                                  placement: "top",
                                  "max-width": 500,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-size-14 ellipsis" },
                                  [_vm._v(_vm._s(scope.row.name))]
                                ),
                              ]
                            ),
                            scope.row.secrecy === 1
                              ? _c(
                                  "yxt-tag",
                                  {
                                    key: "保密",
                                    staticClass: "ml8 yxtbiz-table-row__tag",
                                    attrs: { type: "warning", size: "mini" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("pc_ote_tip_secrecy")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "yxt-tooltip",
                              {
                                staticClass: "ml8",
                                attrs: {
                                  content: _vm.getShareInfor(scope.row),
                                  placement: "top",
                                },
                              },
                              [
                                scope.row.shared === 1
                                  ? _c("yxt-svg", {
                                      staticClass: "hand yxtbiz-table-row__tag",
                                      attrs: {
                                        "icon-class": "icon-share",
                                        width: "18px",
                                        height: "18px",
                                        "remote-url": _vm.mediaUrl,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            scope.row.shareSourceType === 1
                              ? _c(
                                  "yxt-tag",
                                  {
                                    key: "集团标识",
                                    staticClass: "ml8 yxtbiz-table-row__tag",
                                    attrs: { type: "warning", size: "mini" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("pc_biz_ote_btn_share")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  prop: "createFullname",
                  label: _vm.$t("pc_biz_lbl_creator" /*创建人*/),
                  width: 160,
                  "show-overflow-tooltip": true,
                  "popover-html": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("yxtbiz-user-name", {
                          attrs: { name: scope.row.createFullname || "--" },
                        }),
                        scope.row.createFullname
                          ? [
                              _vm._v("\n            ("),
                              _c("yxtbiz-user-name", {
                                attrs: { name: scope.row.createUserName },
                              }),
                              _vm._v(")\n          "),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: _vm.$t("pc_biz_ote_lbl_updatetime"),
                  width: 140,
                  formatter: _vm.shortDate,
                  sortable: "custom",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt16 text-right" },
            [
              _c("yxt-pagination", {
                attrs: {
                  "page-size": _vm.pager.limit,
                  total: _vm.pager.count,
                  "current-page": _vm.pager.current,
                  layout: "total, prev, pager, next",
                },
                on: { "current-change": _vm.handleCurrentChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-lib-flex flex-col flex-g-1 pt24 pl24 pr24" },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-lib-flex flex-between" },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("pc_ote_lbl_choosed_queslib_text" /* 已选题库 */)
                  )
                ),
              ]),
              _vm.needMutiple && _vm.checkedInfo.length
                ? _c(
                    "yxt-button",
                    { attrs: { type: "text" }, on: { click: _vm.clearAllQus } },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_clearall")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.checkedInfo.length
            ? _c(
                "div",
                {
                  staticClass: "mt16 mfl8",
                  class: {
                    "yxtbiz-lib-selector__right--qus flex-g-1": _vm.needMutiple,
                  },
                },
                [
                  _c(
                    "yxt-scrollbar",
                    { ref: "rightScrollbar", staticClass: "yxtbiz-hp100" },
                    _vm._l(_vm.checkedInfo, function (info) {
                      return _c(
                        "yxt-tag",
                        {
                          key: info.id,
                          staticClass:
                            "yxtbiz-lib-selector__right--tag ml8 mb8",
                          attrs: {
                            size: "small",
                            type: "info",
                            closable: "",
                            "disable-transitions": true,
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(info)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "yxt-tooltip",
                                {
                                  attrs: {
                                    content: info.name,
                                    placement: "top",
                                    "open-filter": "",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "ellipsis" }, [
                                    _vm._v(_vm._s(info.name)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.needPointSet && !_vm.needMutiple && _vm.checkedInfo.length
            ? _c(
                "yxt-form",
                {
                  staticClass: "mt16",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                    isNeedRequire: "",
                  },
                },
                [
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pc_ote_btn_batchsetpoints" /* 设置考核点 */
                        ),
                        prop: "points",
                      },
                    },
                    [
                      _c(
                        "yxt-radio-group",
                        {
                          attrs: { direction: "row" },
                          on: { change: _vm.changeRadioGroup },
                          model: {
                            value: _vm.ruleForm.points,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "points", $$v)
                            },
                            expression: "ruleForm.points",
                          },
                        },
                        [
                          _c("yxt-radio", { attrs: { label: "0" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_ote_lib_transfer_points_radio1" /* 统一到所选的考核点下 */
                                )
                              )
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.ruleForm.points === "0",
                                  expression: "ruleForm.points === '0'",
                                },
                              ],
                              staticClass: "bg-gray-1 pv16 ph16",
                            },
                            [
                              _c("ques-point-selector", {
                                staticClass: "clazz_width_100",
                                attrs: {
                                  libId: _vm.checkedInfo[0].id,
                                  selectSize: "small",
                                  selectClass: "clazz_width_100",
                                  "multiple-limit": 5,
                                },
                                model: {
                                  value: _vm.ruleForm.pointLists,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "pointLists", $$v)
                                  },
                                  expression: "ruleForm.pointLists",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("yxt-radio", { attrs: { label: "1" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_ote_lib_transfer_points_radio2" /* 试题考核点复制到所选题库 */
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_ote_btn_createquestionlib"),
            size: "640px",
            visible: _vm.libDetail.isShowDrawer,
            "before-close": function (done) {
              return done(_vm.$refs["libEditor"].isChange)
            },
            destroyOnClose: true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.libDetail, "isShowDrawer", $event)
            },
          },
        },
        [
          _vm.libDetail.isShowDrawer
            ? _c("QuesLibDetail", {
                ref: "libEditor",
                attrs: {
                  catalogId: _vm.libDetail.catalogId,
                  catalogName: _vm.libDetail.catalogName,
                  createType: _vm.createType,
                },
                on: {
                  closeLibDrawer: _vm.closeLibDrawer,
                  search: _vm.setCreateVal,
                  saveBtnStatus: _vm.saveBtnStatus,
                },
              })
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.closeLibDrawer } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.libDetail.btnDisabled,
                    loading: _vm.libDetail.btnDisabled,
                  },
                  on: { click: _vm.save },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_biz_ote_btn_confirm")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }